import { render, staticRenderFns } from "./setPrivate.vue?vue&type=template&id=7fd47c16&scoped=true"
import script from "./setPrivate.vue?vue&type=script&lang=js"
export * from "./setPrivate.vue?vue&type=script&lang=js"
import style0 from "./setPrivate.vue?vue&type=style&index=0&id=7fd47c16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd47c16",
  null
  
)

export default component.exports